<script>
  import { onMount } from "svelte";

  export let id;
  export let value;
  export let current;
  export let focused = false;
  export let error = false;

  let digit;

  //$: console.log("error", error);

  const DIGIT = /\d/;
  const handle_keydown = (e) => {
    if (e.key == "Backspace" || e.key == "Delete" || DIGIT.test(e.key)) {
      return true;
    }
    e.preventDefault();
    return false;
  };

  onMount(() => {
    if (focused) {
      digit.focus();
    }
  });
</script>

<div class="digit" class:in={current === id} class:filled={value} class:error>
  <input
    bind:this={digit}
    name={id}
    bind:value
    on:keydown={handle_keydown}
    on:focus={(e) => (current = id)}
    on:blur={() => (current = null)}
    required
    type="text"
    pattern="[0-9]?"
    size="1"
    minlength="1"
    maxlength="1"
    autocomplete="off" />
</div>

<style>
  .digit {
    display: block;
    position: relative;
    border-radius: 5px;
    border: 1px solid var(--primary-color);
    background-color: #d4d4d4;
  }

  .digit.filled {
    background-color: var(--primary-light-color) !important;
  }

  .digit.filled > input {
    color: white;
  }

  .digit.in {
    background-color: #fafafa;
  }

  .digit > input {
    background-color: transparent;
    -webkit-appearance: none;
    border: 0;
    border-radius: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #666;
    font-size: 24px;
    resize: none;
    vertical-align: middle;
    width: 40px;
    padding: 0;
    text-align: center;
    margin: 5px;
    line-height: 2em;
  }

  .digit.filled.error {
    background-color: var(--error-color) !important;
  }
</style>
